import React from 'react'
import Back from './SVG/mobile.png'
import './MobileScreen.css'
import AboutMe from './AboutMe'
import Home from './Home'
import Contact from './Contact'


class MobileScreen extends React.Component{
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = {
        }
      }
  
      render() {
        return(
            <>
            <div className={`line ${this.props.isActive ? "active" : "notActive"}`}></div>
            <div className={`linetwo ${this.props.isActive ? "active" : "notActive"}`}></div>
            <div className={`mobiletop ${this.props.isActive ? "active" : "notActive"}`}>
                
                <div className='mobiletitle'>{this.props.title}</div>
                <div className='mobileback'><img src={Back} alt=""/></div>
                <div className='mobilecontent' id='content' ref={this.ref}>
                    {(this.props.title === 'About Me') ? <AboutMe /> : null}
                    {(this.props.title === 'Home') ? <Home /> : null}
                    {(this.props.title === 'Contact') ? <Contact /> : null}
                </div>
            </div>
            </>
        )
      }
      componentDidUpdate() {
        this.ref.current.scrollTop=0;  
      }
      onScroll() {
        this.props.handleScroll( this.ref.current.scrollTop );
        }
}

export default MobileScreen


